import type { GameweekPoints, ManagerProfile, ManagerSummary } from '@/types';

/**
 * The verification code the demo build accepts.
 *
 * Only used when no API is configured — a real backend sends a real SMS. The
 * value ships in the bundle, so this is a gate on a shared link, not security.
 * It matches the code the API itself accepts under `AUTH_DISABLED`, so the same
 * sign-in screen works against a local backend without one.
 */
export const DEMO_OTP_CODE = '123456';

export const MOCK_PROFILE: ManagerProfile = {
  id: 'mgr_alex_morgan',
  name: 'Alex Morgan',
  email: 'alex.morgan@gmail.com',
  teamName: 'Mumbai Strikers',
  joined: 'August 2026',
};

export const MOCK_HISTORY: readonly GameweekPoints[] = [
  { gameweek: 1, points: 48, rank: 2104 },
  { gameweek: 2, points: 61, rank: 1780 },
  { gameweek: 3, points: 55, rank: 1602 },
  { gameweek: 4, points: 61, rank: 1360 },
  { gameweek: 5, points: 68, rank: 1248 },
];

export const MOCK_SUMMARY: ManagerSummary = {
  gameweekPoints: 68,
  totalPoints: 293,
  overallRank: 1248,
  rankMovement: 112,
  monthlyRank: 84,
  bestGameweekPoints: 68,
  teamValue: 102.0,
  bank: 1.4,
  freeTransfers: 1,
};
